import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme) => ({
  filtersBar: {
    marginBottom: 20,
    padding: 10,
  },
  btn: {
    marginLeft: 13,
    background: '#F0F3F7',
    '&:hover': {
      background: '#dfe6ee',
    },
  },
  label: {
    marginBottom: 10,
    fontSize: 15,
    fontWeight: 600,
    color: '#fff',
    // [theme.breakpoints.down(theme.size.sm)]: {
    //   marginRight: 0,
    //   marginBottom: 10,
    // },
  },
  value: {
    fontSize: 15,
    fontWeight: 400,
    color: '#fff',
  },
  datePickersWrapper: {
    display: 'flex',
  },
  controlWrapper: {
    flexDirection: 'column',
    alignItems: 'flex-start',
    // [theme.breakpoints.down(theme.size.sm)]: {
    //   flexDirection: 'column',
    //   alignItems: 'flex-start',
    // },
  },
  btnsWrapper: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
  },
}));
